/* eslint-disable */
// @ts-nocheck
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */

import * as Types from '../../../../../../../../api/graphql/generated';

import { api } from 'api/graphql/baseGraphqlApi';
module.hot?.accept();
export type UpdatePackageGroupMutationVariables = Types.Exact<{
  input: Types.MutatePackageGroupInput;
}>;


export type UpdatePackageGroupMutation = { __typename?: 'Mutation', updatePackageGroup?: { __typename?: 'PackageGroup', id: string } | null };


export const UpdatePackageGroupDocument = `
    mutation updatePackageGroup($input: MutatePackageGroupInput!) {
  updatePackageGroup(input: $input) {
    id
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (build) => ({
    updatePackageGroup: build.mutation<UpdatePackageGroupMutation, UpdatePackageGroupMutationVariables>({
      query: (variables) => ({ document: UpdatePackageGroupDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useUpdatePackageGroupMutation } = injectedRtkApi;

